import { render, staticRenderFns } from "./EmployeeperformancePage.vue?vue&type=template&id=4d9f6644"
import script from "./EmployeeperformancePage.vue?vue&type=script&lang=js"
export * from "./EmployeeperformancePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports